import { BarChart, ResponsiveContainer } from "recharts";

interface Props {
  data: any[];
  children: React.ReactNode;
}

export default function BaseBarChart({ data, children }: Props) {
  return (
    <ResponsiveContainer width={"100%"} height={"95%"}>
      <BarChart
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        barGap={0}
      >
        {children}
      </BarChart>
    </ResponsiveContainer>
  );
}
